import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteDeliveryLocation } from "../../../apis";
import { DeleteDeliveryZoneModalProps } from "./DeleteDeliveryLocationModal.types";

import styles from "./DeleteDeliveryLocationModal.module.scss";

const DeleteDeliveryZoneModal = ({
  isOpen,
  location,
  onClose
}: DeleteDeliveryZoneModalProps) => {
  const { t } = useTranslation();

  const deleteDeliveryLocation = useDeleteDeliveryLocation({
    onSuccess: () => {
      onClose();
    }
  });

  const getTitle = () => {
    if (location.areaName) {
      return "Delete Area";
    }
    if (location.cityName) {
      return "Delete City";
    }
    return "Delete Country";
  };

  const getText = () => {
    if (location.areaName) {
      return t("Are you sure you want to delete this area?");
    }
    if (location.cityName) {
      return t("Are you sure you want to delete this city?");
    }
    return t("Are you sure you want to delete this country?");
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={getTitle()}
      isLoading={deleteDeliveryLocation.isLoading}
      okText="Delete"
      onOk={() => deleteDeliveryLocation.mutate(location)}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.modal_text}>{getText()}</p>
    </Modal>
  );
};

export default DeleteDeliveryZoneModal;
